import { handleDocumentOnDevice } from "web_myplann/Api/Document/handleDocumentOnDevice";
import { useDocumentMutation } from "web_myplann/Api/Document/useDocumentMutation";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { HandleDocumentTypes } from "web_myplann/Utils/WebViewModel";

export const useShareDocumentMutation = () =>
	useDocumentMutation<void>({
		errorResource: Resources.Common.documentShareFailed,
		deliver: (document, errorMessage) =>
			handleDocumentOnDevice({
				base64: document.base64,
				filename: document.filename,
				mimeType: document.mimeType,
				actionType: HandleDocumentTypes.SHARE,
				errorMessage,
			}),
	});
